<template>
  <div class="bbp-reminder-panel-form-recur">
    <div class="bbp-reminder-panel-form-recur__wrap">
      <div class="bbp-reminder-panel-form-recur__label">
        Recur
      </div>
      <BBPSelectInput
        :input="selectSettings"
        :model="valueObj"
        @input="onChangeSelect"
      />
    </div>
    <div class="bbp-reminder-panel-form-recur__wrap">
      <div class="bbp-reminder-panel-form-recur__label">
        Ends
      </div>
      <div class="bbp-reminder-panel-form-recur-ends">
        <BBPRadio
          :input="rationSettings"
          :model="valueObj"
          @input="onChangeRadio"
        />
        <div :class="{'bbp-reminder-panel-form-recur__disabled': isDisabled}">
          <BBPDatePicker
            :input="calendarSettings"
            :model="valueObj"
            @input="onChangeDate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BBPSelectInput from '@/components/Main/BBPForm/BBPSelectInput/BBPSelectInput'
import BBPDatePicker from '@/components/Main/BBPForm/BBPDatePicker/BBPDatePicker'
import BBPRadio from '@/components/Main/BBPForm/BBPRadio/BBPRadio'
import { RECUR_REMINDERS, RECUR_RADIO_LIST, RECUR_RADIO_NEVER } from '@/constants/recurReminders'

export default {
  name: 'BBPReminderPanelFormRecur',
  components: {
    BBPSelectInput,
    BBPDatePicker,
    BBPRadio
  },
  props: {
    valueObj: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    selectSettings: {
      listLabel: 'key',
      model: 'status',
      placeholder: 'No entries',
      options: RECUR_REMINDERS
    },
    calendarSettings: {
      mode: 'single',
      model: 'endDate',
      isScreens: true,
      minDate: new Date()
    },
    rationSettings: {
      listLabel: 'key',
      model: 'ends',
      options: RECUR_RADIO_LIST
    }
  }),
  computed: {
    isDisabled () {
      const { ends } = this.valueObj
      return ends === RECUR_RADIO_NEVER.id
    }
  },
  methods: {
    onChangeSelect (item) {
      this.valueObj.status = item
    },
    onChangeRadio (item) {
      const { options } = this.rationSettings
      const currentItem = options.find((el) => el.id === item)
      this.valueObj.ends = currentItem
    },
    onChangeDate (item) {
      this.valueObj.endDate = item
    }
  },
  beforeMount () {
    const { status } = this.valueObj
    const { options } = this.selectSettings
    if (!Object.keys(status).length) {
      this.valueObj.status = options[0]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bbp-reminder-panel-form-recur {
    display: grid;
    grid-template-columns: 87px 1fr;
    grid-gap: 0 36px;

    &__label {
      margin: 0 0 8px 0;
      font-size: 13px;
      line-height: 16px;
      font-weight: 600;
      color: $color-denim;
    }
  }

  .bbp-reminder-panel-form-recur-ends {
    display: grid;
    grid-template-columns: 139px 1fr;
    align-items: center;
  }
</style>

<style lang="scss">
@import "../../../../../../sass/variables";
  .bbp-reminder-panel-form-recur {
    .bbp-select-header {
      min-height: 29px !important;
      max-height: 29px;
      padding: 7px 0 7px 8px !important;
    }

    .bbp-radio-form-item {
      margin-right: 31px !important;
    }

    .bbp-date-picker-body {
      padding: 5px 8px !important;
      grid-template-columns: 1fr 17px !important;
    }

    .bbp-time-picker .time-picker input {
      height: 29px !important;
      width: 82px !important;
    }

    &__disabled {
      .bbp-date-picker {
        pointer-events: none;
        cursor: none;
      }

      .bbp-date-picker-body {
        background: $color-wild-sand;

        &__date {
          color: $color-gray;
        }

        &__icon {
          color: $color-gray;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelForm/BBPReminderPanelFormRecur.vue